import React from 'react';
import { motion } from 'framer-motion';
import { getStaticAsset, STATIC_ASSETS, preloadImage } from '../../utils/staticAssets';



const EcosystemPage = () => {
  const ecosystemFeatures = [
    "Hosting a range of MMO, RPG, and strategy Web3 titles",
    "Partnered with veteran teams from Steam, Epic Games, and Amazon",
    "Offering grants and technical support for traditional studios transitioning into GameFi"
  ];

  return (
    <div className="page-container relative">
      {/* Background */}

    <div className="content-container relative z-10 h-full flex flex-col md:flex-row  flex-wrap  " >
      <div className="w-full flex justify-start md:pr-[150px] pr-4 pt-4">
        <img
          src={STATIC_ASSETS.LOGO}
          className="w-[100px] h-[100px] md:w-[302px] md:h-[302px]"
        />
      </div>


  {/* 主要内容区域（垂直布局 → 水平布局） */}
  <div className="w-full flex flex-col md:flex-row">
    {/* 左侧文字内容 */}
    <div className="w-full md:w-[50%] flex justify-center px-4 md:px-0">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
        className="flex flex-col w-full md:w-[60%]"
      >
        <motion.h1
          className="text-2xl md:text-4xl gradient-text mb-4 md:mb-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          The Gmatrixs Ecosystem
        </motion.h1>

        <motion.div
          className="space-y-4 md:space-y-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {ecosystemFeatures.map((feature, index) => (
            <motion.div
              key={index}
              className="flex items-start space-x-4"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.6 + index * 0.2 }}
            >
              <motion.div
                className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex-shrink-0"
                whileHover={{ scale: 1.5 }}
                transition={{ duration: 0.3 }}
              />
              <p className="text-base md:text-xl text-white leading-relaxed text-left">
                {feature}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </div>

    {/* 右侧游戏图片 */}
    <div className="w-full md:w-[50%] flex justify-center md:justify-end mt-8 md:mt-0 md:pr-[150px] px-4 md:px-0">
      <motion.div
        className="flex justify-center md:justify-end items-center w-full"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <motion.div
          className="relative w-full max-w-md"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.3 }}
        >
          {/* Main Game Image Container */}
          <div className="bg-black rounded-3xl p-4 shadow-2xl border border-gray-800">
            <motion.img
              src="https://c.animaapp.com/mgze3elxBshhyd/img/---------1--10--2.png"
              alt="Game Ecosystem"
              className="w-full rounded-2xl object-cover"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            />
          </div>

          {/* Floating Game Icons (缩小尺寸) */}
          <motion.div
            className="absolute -top-4 -left-4 w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            whileHover={{ rotate: 360 }}
          >
            <span className="text-white font-bold text-lg">🎮</span>
          </motion.div>

          <motion.div
            className="absolute -top-2 -right-4 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-purple-600 to-blue-500 rounded-xl flex items-center justify-center shadow-lg"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1 }}
            whileHover={{ rotate: -360 }}
          >
            <span className="text-white font-bold">⚔️</span>
          </motion.div>

          <motion.div
            className="absolute -bottom-4 -right-2 w-10 h-10 md:w-14 md:h-14 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.2 }}
            whileHover={{ rotate: 180 }}
          >
            <span className="text-white font-bold">🏰</span>
          </motion.div>

          <motion.div
            className="absolute -bottom-2 -left-4 w-8 h-8 md:w-10 md:h-10 bg-gradient-to-r from-purple-600 to-blue-500 rounded-lg flex items-center justify-center shadow-lg"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.4 }}
            whileHover={{ rotate: -180 }}
          >
            <span className="text-white font-bold text-sm">💎</span>
          </motion.div>

          {/* Glow Effect */}
          <motion.div
            className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-500/20 to-purple-600/20 blur-xl -z-10"
            animate={{ 
              scale: [1, 1.1, 1],
              opacity: [0.3, 0.6, 0.3]
            }}
            transition={{ 
              duration: 4, 
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>
      </motion.div>
    </div>
  </div>

  {/* 背景动画元素（调整位置和尺寸） */}
  <motion.div
    className="absolute top-1/6 left-1/6 w-16 h-16 md:w-24 md:h-24 opacity-20"
    animate={{ 
      rotate: [0, 360],
      scale: [1, 1.2, 1]
    }}
    transition={{ 
      duration: 15, 
      repeat: Infinity,
      ease: "linear"
    }}
  >
    <div className="w-full h-full rounded-full bg-gradient-to-r from-blue-500 to-purple-600 blur-lg" />
  </motion.div>

  <motion.div
    className="absolute bottom-1/6 right-1/6 w-12 h-12 md:w-20 md:h-20 opacity-15"
    animate={{ 
      y: [0, -15, 0],
      x: [0, 10, 0],
      rotate: [0, 180, 360]
    }}
    transition={{ 
      duration: 10, 
      repeat: Infinity,
      ease: "easeInOut"
    }}
  >
    <div className="w-full h-full rounded-full bg-gradient-to-r from-purple-600 to-blue-500 blur-lg" />
  </motion.div>

  <motion.div
    className="absolute top-1/2 right-1/4 w-10 h-10 md:w-16 md:h-16 opacity-10"
    animate={{ 
      scale: [1, 1.2, 1],
      rotate: [0, -360, 0]
    }}
    transition={{ 
      duration: 8, 
      repeat: Infinity,
      ease: "easeInOut"
    }}
  >
    <div className="w-full h-full rounded-full bg-gradient-to-r from-blue-500 to-purple-600 blur-lg" />
  </motion.div>
</div>


     
    </div>
  );
};

export default EcosystemPage;